import { render, staticRenderFns } from "./ShopPicker.vue?vue&type=template&id=3348ffcc&scoped=true&"
import script from "./ShopPicker.vue?vue&type=script&lang=js&"
export * from "./ShopPicker.vue?vue&type=script&lang=js&"
import style0 from "./ShopPicker.vue?vue&type=style&index=0&id=3348ffcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3348ffcc",
  null
  
)

component.options.__file = "ShopPicker.vue"
export default component.exports